import type { NskResponse } from "~/models/Api";
import { postRequest } from "~/utils/api/api_handler";

const paths = {
	create: "/vendors/deals/:deal_id/deal_completion_check_files"
} as const;

export const create = async (
	file: File,
	dealId: number
): Promise<NskResponse> => {
	const params = new FormData();
	params.append("file", file);
	return postRequest(paths.create.replace(":deal_id", String(dealId)), params);
};
